<template>
  <div
    class="filter-group"
    data-filter
    :class="{ 'filter-group--open': filter.isOpen }"
  >
    <button
      class="filter-group__trigger"
      @click="toggleFilterDropdown(filter.index)"
    >
      {{ filter.label }}
      <span v-if="filter.activeFilters > 0">{{ filter.activeFilters }}</span>
      <ChevronRightIcon />
    </button>

    <transition name="fadeup">
      <div
        v-show="filter.isOpen"
        v-cloak
        class="filter-group__display"
      >
        <template v-if="isPriceFilter" />
        <ul
          v-else
          class="filter-group-display__list"
        >
          <li
            v-for="(value, index) in filter.values"
            :key="value.label"
            class="filter-group__display-list-item"
          >
            <input
              :id="`Filter-${filter.paramName}-${index}`"
              type="checkbox"
              name="{{ filter_value.param_name }}"
              value="{{ filter_value.value }}"
              :checked="value.active"
              :disabled="value.count === 0 && !value.active"
              @change="toggleFilter(filter.index, index)"
            >
            <label
              :for="`Filter-${filter.paramName}-${index}`"
              class="flex items-center checkbox-label"
            >
              <span>
                {{ isFlavour ? value.label.split(':')[1].replace(/-/g, ' ') : value.label }}
              </span>
            </label>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import { useCollectionStore } from '../pinia/CollectionStore'

import ChevronRightIcon from '../icons/chevron-right'


export default {
  components: {
    ChevronRightIcon
  },
  props: {
    filter: {
      type: Object,
      default: null
    }
  },
  computed: {
    isPriceFilter () {
      return this.filter.type === 'price_range'
    },
    isFlavour () {
      return this.filter.label === 'Flavours'
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions (useCollectionStore, [
      'toggleFilterDropdown',
      'toggleFilter'
    ]),
  }
}
</script>
